export * from './brochure.component'
